import Card from "./card.js";
export default class ControlCard extends Card {
  constructor(l, t, s, i, n, r) {
    super(l, t, null, null, null, null, s, null, i, null, null, null, n, r),
      (this.isControl = !0),
      (this.U = "ab-control-card"),
      (this.V = !1);
  }
  tt() {
    const l = {};
    return (
      (l[Card.it.st] = Card.et.Ut),
      (l[Card.it.rt] = this.id),
      (l[Card.it.ot] = this.viewed),
      (l[Card.it.ut] = this.updated),
      (l[Card.it.xt] = this.expiresAt),
      (l[Card.it.jt] = this.extras),
      (l[Card.it.zt] = this.pinned),
      (l[Card.it.vt] = this.test),
      l
    );
  }
}
